import React, { useEffect, useState } from "react";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Button from "react-bootstrap/esm/Button";
import toast, { Toaster } from "react-hot-toast";

function PickNewGame(props) {
  const [itemArray, setItemArray] = useState([]);
  const [currentItemArray, setCurrentItemArray] = useState([]);
  const [grid, setGrid] = useState([]);
  const [count, setCount] = useState(-1);
  const [incorrectCount, setIncorrectCount] = useState(0);
  const [number, setNumber] = useState(15);
  const [itemFlag, setItemFlag] = useState(true);

  const handleGetItems = async () => {
    const response = await makeGetRequest(
      urls.getIcons + "?active=True",
      "",
      true
    );
    setItemArray(response.data);
    setCount(0);
  };

  useEffect(() => {
    handleGetItems();
  }, []);

  useEffect(() => {
    if (currentItemArray)
      if (itemArray.length > 1) {
        if (currentItemArray.length === count) {
          let newItem = itemArray[count];
          let location = Math.floor(Math.random() * 15);
          do {
            location = Math.floor(Math.random() * 15);
          } while (
            currentItemArray.findIndex((item) => item.location === location) !==
            -1
          );
          setCurrentItemArray((prevArray) => [
            ...prevArray,
            {
              id: newItem.id,
              item: newItem.item,
              image: newItem.image,
              location: Math.floor(Math.random() * 15),
            },
          ]);
        }
      }
  }, [count]);

  useEffect(() => {
    createGrid();
  }, [currentItemArray]);

  const identity = (id) => {
    let item = currentItemArray.filter((item) => item.id === id);
    if (currentItemArray[count].id === id) {
      toast("That is correct the " + item[0].item + " was correct!", {
        duration: 3000,
        position: "right",
      });
      setCount((prevCount) => prevCount + 1);
    } else {
      setIncorrectCount((prevCount) => prevCount + 1);
      toast(
        "Sorry the " + item[0].item + " was incorrect. It was already here.",
        {
          duration: 3000,
          position: "right",
        }
      );
    }
  };

  useEffect(() => {
    props.setCount(count);
    props.setNumber(number);
    props.setIncorrectCount(incorrectCount);
  }, [count, incorrectCount]);

  const createGrid = () => {
    let newGridComp = "";
    let addAllGrids = [];
    for (let i = 0; i < 15; i++) {
      if (currentItemArray[i]) {
        newGridComp = (
          <Col style={{ textAlign: "center" }} key={Math.random()}>
            <Button
              onClick={() => identity(currentItemArray[i].id)}
              key={i}
              style={{
                width: "100px",
                margin: "12px",
                height: "85px",
                opacity: 1,
              }}
            >
              <img
                src={currentItemArray[i].image}
                style={{
                  width: "64px",
                  height: "64px",
                  opacity: 1,
                }}
              ></img>
            </Button>
          </Col>
        );
      } else {
        newGridComp = (
          <Col style={{ textAlign: "center" }} key={Math.random()}>
            <Button
              onClick={() => identity(i)}
              key={i}
              style={{
                width: "100px",
                margin: "12px",
                height: "85px",
                opacity: 0,
              }}
              disabled
            >
              {i}
            </Button>
          </Col>
        );
      }
      addAllGrids.push(newGridComp);
    }
    setGrid(
      addAllGrids
        .map((value) => {
          return { i: value, id: Math.random() };
        })
        .sort((a, b) => a.id - b.id)
        .map((item) => item.i)
    );
  };

  return (
    <>
      <Row>{grid}</Row>
    </>
  );
}

export default PickNewGame;
